import styled from "styled-components";

export const ButtonNavStyled = styled.button<{
	$backgroundColor?: string;
	$color?: string;
}>`
	font-weight: 600;
	padding: 1.5rem 2.5rem;
	color: var(${(props) => props.$color});
	background-color: var(${(props) => props.$backgroundColor});

	box-shadow: 1px 2px 5px var(--color-gray-1);
	transition: all 0.3s ease;

	&:hover {
		background-color: var(--color-white-fixed);
		box-shadow: 1px 2px 5px var(--color-gray-0);
		color: var(--color-brand-5);
	}
`;
